module.exports = __webpack_public_path__ + "static/media/1-3.e924b536.PNG";